module.exports = __webpack_public_path__ + "static/media/question2.0f64ca07.svg";